export const NOT_ALLOWED_SYMBOLS = [":", ";", '"', "<", ">", "/"];
